module.exports = __webpack_public_path__ + "img/battery_4classic.3d1491d3.png";